import {
  U21TableBodyCellProps,
  U21TableColumn,
  U21TableColumnTypes,
} from 'app/shared/u21-ui/components';
import { SarStatusTypes } from 'app/modules/fincenSAR/models';
import { GoAMLStatusLabel } from 'app/modules/goAML/components/GoAMLStatusLabel';
import {
  GoAMLFilingDetails,
  GoAMLTxnSelection,
  TransactionTableData,
} from 'app/modules/goAML/models';
import { humanReadableFileSize } from 'app/shared/helpers';
import { REPORT_INDICATORS_CODE_TABLE } from 'app/modules/goAML/schemas/catalogues/reportIndicators';
import { ShortSARFilingResponse } from 'app/modules/fincenSAR/responses';

export const GO_AML_COLUMNS: U21TableColumn<ShortSARFilingResponse, any>[] = [
  {
    accessor: 'id',
    Header: 'ID',
    id: 'id',
    type: U21TableColumnTypes.TEXT,
  },
  {
    accessor: 'name',
    Header: 'Name',
    id: 'name',
    type: U21TableColumnTypes.TEXT,
  },
  {
    accessor: 'created_at',
    Header: 'Created at',
    id: 'created_at',
    type: U21TableColumnTypes.DATETIME,
  },
  {
    accessor: 'created_by.full_name',
    Header: 'Created by',
    id: 'created_by',
    type: U21TableColumnTypes.TEXT,
  },
  {
    accessor: 'updated_at',
    Header: 'Updated at',
    id: 'updated_at',
    type: U21TableColumnTypes.DATETIME,
  },
  {
    accessor: 'status',
    Header: 'Status',
    id: 'status',
    Cell: ({
      value,
    }: U21TableBodyCellProps<ShortSARFilingResponse, SarStatusTypes>) => (
      <GoAMLStatusLabel status={value} />
    ),
  },
];

export const GO_AML_ACTIONS_COLUMN: U21TableColumn<ShortSARFilingResponse> = {
  id: 'actions',
  type: U21TableColumnTypes.ACTIONS,
};

export const TRANSACTION_COLUMNS: U21TableColumn<TransactionTableData>[] = [
  {
    accessor: 'date_transaction',
    Header: 'Transaction date',
    id: 'date_transaction',
    type: U21TableColumnTypes.DATE,
  },
  {
    accessor: 'transactionnumber',
    Header: 'Transaction number',
    id: 'transactionnumber',
    type: U21TableColumnTypes.TEXT,
  },
  {
    accessor: 'amount_local',
    Header: 'Amount',
    id: 'amount_local',
    type: U21TableColumnTypes.TEXT,
  },
  {
    accessor: 'transmode_code',
    Header: 'Transaction code',
    id: 'transmode_code',
    type: U21TableColumnTypes.TEXT,
  },
];

export const TRANSACTION_ACTIONS_COLUMN: U21TableColumn<TransactionTableData> =
  {
    id: 'actions',
    type: U21TableColumnTypes.ACTIONS,
  };

export const INDICATORS_COLUMNS: U21TableColumn<
  (typeof REPORT_INDICATORS_CODE_TABLE)[number]
>[] = [
  { id: 'code', accessor: 'code', Header: 'Code', width: 50 },
  {
    id: 'indicator',
    accessor: 'indicator',
    Header: 'Indicator',
    width: 300,
  },
];

export const ATTACHMENT_COLUMNS: U21TableColumn<
  GoAMLFilingDetails['attachments'][number],
  any
>[] = [
  {
    id: 'name',
    accessor: 'name',
    Header: 'File name',
    type: U21TableColumnTypes.TEXT,
    width: 300,
  },
  {
    id: 'size',
    accessor: (row) =>
      row.file_size ? humanReadableFileSize(row.file_size) : undefined,
    Header: 'Size',
    type: U21TableColumnTypes.TEXT,
  },
  {
    accessor: 'created_at',
    Header: 'Uploaded at',
    id: 'created_at',
    type: U21TableColumnTypes.DATETIME,
  },
];

export const ATTACHMENT_ACTIONS_COLUMN: U21TableColumn<
  GoAMLFilingDetails['attachments'][number],
  any
> = {
  id: 'actions',
  type: U21TableColumnTypes.ACTIONS,
};

export const CREATE_TRANSACTION_COLUMNS: U21TableColumn<GoAMLTxnSelection>[] = [
  {
    id: 'external_id',
    accessor: 'external_id',
    Header: 'Transaction ID',
    type: U21TableColumnTypes.TEXT,
  },
];

export const CREATE_TRANSACTION_FROM_COLUMN: U21TableColumn<GoAMLTxnSelection> =
  {
    id: 'from',
    accessor: 'from',
    Header: 'From',
  };

export const CREATE_TRANSACTION_TO_COLUMN: U21TableColumn<GoAMLTxnSelection> = {
  id: 'to',
  accessor: 'to',
  Header: 'To',
};
